/**
 * Atomic Edu — Microsoft Clarity bootstrap.
 *
 * Loads the official Clarity tag exactly as documented in the
 * Clarity install page, but reads the project ID from
 * `REACT_APP_CLARITY_PROJECT_ID` so we never hardcode the ID into
 * the bundle / git history.
 *
 * Clarity gives us:
 *   - Session recordings (visual replays of every visit)
 *   - Heatmaps (click / scroll / area)
 *   - Rage-click & dead-click detection
 *
 * Privacy posture (matches the PostHog module):
 *   - Clarity masks all input/textarea content by default.
 *   - Any panel that should be excluded from session replay can be
 *     marked with the `data-clarity-mask` attribute on the wrapper
 *     element.
 *   - We do NOT call `clarity("identify", ...)` with email — Clarity
 *     replays are accessed by anonymous session ID only.
 */

const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID || "";

let initialised = false;

/**
 * Inject the official Clarity loader snippet exactly as published on
 * https://clarity.microsoft.com/. Idempotent — safe to call multiple
 * times. No-ops when the project ID env var is missing (CI / local).
 */
export function initClarity() {
  if (initialised) return true;
  if (!CLARITY_PROJECT_ID) return false;
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }

  // eslint-disable-next-line func-names
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_PROJECT_ID);

  initialised = true;
  return true;
}

// Eager init on import — keeps the API simple and matches the
// PostHog module's lifecycle exactly.
initClarity();
